import React from "react";
import "./VCNRMediaContact.css";
import leftStars from "../../Assets/contact/left-stars.png";   // Replace with your actual path
import rightStars from "../../Assets/contact/right-stars.png"; // Replace with your actual path

const MediaContact = () => {
  return (
    <div className="vcnr-media-contact-wrapper">
      <img src={leftStars} alt="left stars" className="vcnr-left-stars" />
      <div className="vcnr-media-contact-content">
        <h2 className="vcnr-media-title">Media Contact</h2>
        <p className="vcnr-media-email">info@growworld.com</p>
        <div className="vcnr-media-buttons">
          <button className="vcnr-btn vcnr-btn-dark">Download Media Kit</button>
          <button className="vcnr-btn vcnr-btn-purple">
            Schedule Interview with Leadership
          </button>
        </div>
      </div>
      <img src={rightStars} alt="right stars" className="vcnr-right-stars" />
    </div>
  );
};

export default MediaContact;
